/*
    import CacheUtil from '@/assets/utils/CacheUtil'
*/
export default {
    MinimizeContent: 'ticket.MinimizeContent',
    ReplyTicketButtonType : 'ticket.replyTicketButtonType',
    TicketTagList : 'ticket.tag.list',
    TicketUserListCache : 'ticket.user.list.3',
    TicketViewId : 'ticket.view.id',
    TicketOtherMenuOpen : 'ticket.view.otherMenuOpen',
    TicketViewPageSize : 'ticket.view.pageSize',
    SidebarStatus : 'ticket.view.sidebarStatus',
    SearchData : "ticket.view.searchData",
    MobileAppToken : "ticket.MobileAppToken",
    MobileAppTokenFromUrl : "ticket.MobileAppTokenFromUrl",
    RuntimeTokenFromUrl : null,
    AdvancedSearch : "ticket.advancedSearch",
    LoadFormDataIds : 'ticket.LoadFormDataIds',
    UserGuideShow : 'ticket.UserGuideShow_20201016',
    ProjectId : 'ticket.ProjectId',
    MerchantToken : "ticket.MerchantToken",
    FormInline: 'ticket.FormInline',

    isPC() {
        var is = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
        return !is;
    },

    getFormInline() {
        var v = localStorage.getItem(this.FormInline);

        if ( null == v || undefined == v ) {
            return this.isPC(); // PC 默认 true 手机 默认 false
        }

        return v != 'false'; // 默认 横向表单
    },

    setFormInline( _val ) {
        localStorage.setItem(this.FormInline, _val);
    },

    setMerchantToken( _val ) {
        if ( !_val || 'undefined' == '' + _val ) {
            console.log('#23 setMerchantToken, _val=', _val);
            return;
        }

        localStorage.setItem(this.MerchantToken, _val);
    },

    getMerchantToken() {
        return localStorage.getItem(this.MerchantToken);
    },

    getLocalStorageTokenFromUrl() {
        if ( !localStorage || !localStorage.getItem ) {
            console.log('#22 getLocalStorageTokenFromUrl error, no localStorage');
            return null;
        }

        var _val = localStorage.getItem(this.MobileAppTokenFromUrl);

        // console.log('#26 getLocalStorageToken, this.MobileAppToken = ', this.MobileAppToken, ', _val = ', _val);
        return _val;
    },

    getRuntimeTokenFromUrl() {
        return this.RuntimeTokenFromUrl;
    },

    getLocalStorageToken() {
        if ( !localStorage || !localStorage.getItem ) {
            console.log('#20 getLocalStorageToken error, no localStorage');
            return null;
        }

        var _val = localStorage.getItem(this.MobileAppToken);

        // console.log('#26 getLocalStorageToken, this.MobileAppToken = ', this.MobileAppToken, ', _val = ', _val);
        return _val;
    },

    setLocalStorageTokenFromUrl( _val ) {
        console.log('#32 setLocalStorageTokenFromUrl, this.MobileAppToken = ', this.MobileAppToken);

        // 记录本次页面生命周期内由 URL 明确传入的 token，避免被历史缓存覆盖。
        this.RuntimeTokenFromUrl = _val;
        localStorage.setItem(this.MobileAppTokenFromUrl, _val);

        // 记录设置这个Token的时间和当前URL
        localStorage.setItem('ticket.SetLocalStorageMobileAppTokenFromUrlAt', new Date() + ' ' + location.href);
    },

    setLocalStorageToken( _val ) {
        console.log('#28 setLocalStorageToken, this.MobileAppToken = ', this.MobileAppToken, ', _val = ', _val);

        localStorage.setItem(this.MobileAppToken, _val);

        // 记录设置这个Token的时间和当前URL
        localStorage.setItem('ticket.SetLocalStorageMobileAppTokenAt', new Date() + ' ' + location.href);
    },

    removeLocalStorageToken( ) {
        this.removeLocalStorageItem(this.MobileAppToken);
    },

    removeLocalStorageItem( key ) {
        console.log('#16 removeLocalStorageItem', key);

        localStorage.removeItem(key);
    },

    clearCache() {
        this.removeLocalStorageItem(this.ReplyTicketButtonType);
        this.removeLocalStorageItem(this.TicketTagListCache);
        this.removeLocalStorageItem(this.TicketUserListCache);
        this.removeLocalStorageItem(this.TicketViewId);
        this.removeLocalStorageItem(this.TicketOtherMenuOpen);
        this.removeLocalStorageItem(this.TicketViewPageSize);
        this.removeLocalStorageItem(this.SidebarStatus);
        this.removeLocalStorageItem(this.SearchData);
        this.removeLocalStorageItem(this.AdvancedSearch);

        this.removeLocalStorageItem(this.MobileAppToken);
        this.removeLocalStorageItem(this.UserGuideShow);

        _message("清理缓存成功");
    }
};



// WEBPACK FOOTER //
// ./src/assets/utils/CacheUtil.js